export default "__VITE_ASSET__4959b543__"